import { string } from 'yup'

const blePin = (requiredString, pinLengthString, defaultPinMessage) => string()
  .required(requiredString).length(6, pinLengthString).matches(/\d{6}/, pinLengthString)
  .test('blePin', defaultPinMessage, value => value !== '000000')

export default blePin
